import LicenseProduct from './LicenseProduct';

export default LicenseProduct;